var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-form',{attrs:{"title":_vm.title,"show":_vm.value,"save-action-caption":"Confirm"},on:{"saveData":_vm.doConfirm,"update:show":_vm.updateShow}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }